const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'dashboard',
        title: 'Pregled',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard',
        top_level: true,
        permissions: []
    },
    /*{
        name: 'settings',
        title: 'Nastavitve',
        icon: 'mdi-cogs',
        path: '/nastavitve',
        group: 'settings',
        top_level: true,
        permissions: [],
    },*/
    {
        name: 'users_list',
        title: 'Seznam uporabnikov',
        icon: 'mdi-account-group',
        path: '/seznam-uporabnikov',
        group: 'users_list',
        top_level: true,
        permissions: []
    },
    {
        name: 'add_user',
        title: 'Dodaj uporabnika',
        icon: 'mdi-account-plus',
        path: '/dodaj-uporabnika',
        group: 'add_user',
        top_level: true,
        permissions: []
    },

    /*{
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: '/zasedenost-parkirisca',
        group: 'parking_occupancy',
        
    },

    {
        name: 'traffic_lights',
        title: 'Semaforji',
        icon: 'mdi-traffic-light',
        path: '/semaforji',
        group: 'traffic_lights',
    },*/

    /*{
        name: 'parking_barriers',
        title: 'Upravljanje zapornic',
        icon: 'mdi-remote',
        path: '/zapornice',
        group: 'parking_barriers',
    },*/

    {
        name: 'traffic_lights',
        title: 'Semaforji',
        icon: 'mdi-billboard',
        path: '/semaforji',
        group: 'traffic_lights',
        top_level: true,
        permissions: []
    },

    {
        title: 'Potopni stebrički',
        icon: 'mdi-remote',
        group: 'potopni-stebricki', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: [],
        items: [
            {
                name: 'parking_barriers_management',
                title: 'Upravljanje stebričkov',
                icon: 'mdi-android-messages',
                path: '/potopni-stebricki/upravljanje',
                top_level: false,
                permissions: [],
            },
            /*
            {
                name: 'parking_barriers_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/potopni-stebricki/casovnica',
                top_level: false,
                permissions: [],
            },
            */
            {
                name: 'parking_barriers_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/potopni-stebricki/arhiv',
                top_level: false,
                permissions: [],
            }
        ]
    },

    {
        name: 'exports',
        title: 'Izvoz podatkov',
        icon: 'mdi-application-export',
        path: 'izvoz-podatkov',
        group: 'exports',
        top_level: true,
        permissions: []
    },
]

export { Menu }